import { ContainerModule } from 'inversify';
import { CalculateCompetences } from './listeners/calculate-competences';
import { EventStreamListenerSymbol } from '@/app/event-stream';
import { CompetenceService, CompetenceServiceSymbol } from './competence-service';

export const competenceModule = new ContainerModule((bind) => {
  bind(CalculateCompetences).toSelf().inSingletonScope();
  bind(EventStreamListenerSymbol).toDynamicValue((c) => c.container.get(CalculateCompetences));

  bind(CompetenceServiceSymbol).to(CompetenceService).inSingletonScope();
});
